import { Offcanvas } from 'bootstrap';

import { appendQuery, offcanvasUrl } from '@/shared/utils/url';

import { getNonNullGridFilters, refreshGrids } from '@/front/grid';
import { confirmModal } from '@/front/modal';
import { hideSpinner, showSpinner } from '@/front/spinner';

window.addEventListener('expandOffCanvas', () => {
  expandOffCanvas();
});

window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    window.parent.dispatchEvent(new CustomEvent('escape'));
  }
});

window.addEventListener('escape', () => {
  hideOffcanvas();
});

window.addEventListener('setOffcanvasWide', (e) => {
  document.getElementById('offcanvas')?.classList.toggle('wide', (e as CustomEvent<boolean>).detail);
});

window.addEventListener('offcanvasExpandedChange', () => syncExpanded());

document.addEventListener('DOMContentLoaded', () => {
  syncExpanded();

  document.querySelectorAll('a[data-offcanvas="true"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      let url = link.getAttribute('href');

      if (url) {
        e.preventDefault();

        // HACK Grab any grid filter values and tack onto the URL to pre-populate (bit of a hack)
        const gridFilters = getNonNullGridFilters();

        if (gridFilters) {
          url = appendQuery(url, gridFilters);
        }

        // TODO Only refresh grids that have changed
        showOffcanvas({ url, onHide: refreshGrids });
      }
    });
  });
});

export const showOffcanvas = (params: { url: string; onHide?: () => void }) => {
  const { url, onHide } = params;

  showSpinner();

  const offcanvasElement = document.getElementById('offcanvas')!;

  const offcanvas = Offcanvas.getOrCreateInstance(offcanvasElement);

  const iframe = offcanvasElement.querySelector('iframe')!;

  // TODO allow for incoming URL with query string
  iframe.setAttribute('src', offcanvasUrl(url));

  iframe.addEventListener(
    'load',
    () => {
      hideSpinner();
      offcanvas.show();
    },
    {
      once: true,
    },
  );

  const addHideEventListener = () => {
    offcanvasElement.addEventListener(
      'hide.bs.offcanvas',
      async (e) => {
        e.preventDefault();

        const iframe = offcanvasElement.querySelector('iframe');
        const dirtyForm = iframe?.contentWindow?.document.querySelector('form[data-dirty="true"]');

        if (
          !dirtyForm ||
          (await confirmModal('Are you sure you want to close this record without saving changes?', 'Close', 'danger'))
        ) {
          if (onHide) onHide();
          hideOffcanvas();
        } else {
          // Re-add listener if cancelled (only fires successfully once)
          addHideEventListener();
        }
      },
      {
        once: true,
      },
    );
  };

  addHideEventListener();
};

export const expandOffCanvas = () => {
  const offcanvasElement = document.getElementById('offcanvas');

  if (offcanvasElement) {
    offcanvasElement.classList.toggle('expanded');
  } else {
    window.parent.dispatchEvent(new CustomEvent('expandOffCanvas'));
    window.dispatchEvent(new CustomEvent('offcanvasExpandedChange'));
  }
};

export const setOffcanvasWide = (wide: boolean) => {
  window.parent.dispatchEvent(new CustomEvent('setOffcanvasWide', { detail: wide }));
};

export const isOffcanvasExpanded = () => !!window.frameElement?.closest('#offcanvas')?.classList.contains('expanded');

const syncExpanded = () => {
  const expanded = isOffcanvasExpanded();

  document.body.classList.toggle('offcanvas-expanded', expanded);

  document.querySelectorAll<HTMLTableCellElement>('[data-expanded-colspan]').forEach((cell) => {
    cell.dataset.collapsedColspan ??= cell.colSpan.toString();
    cell.colSpan = Number(expanded ? cell.dataset.expandedColspan : cell.dataset.collapsedColspan);
  });
};

export const hideOffcanvas = (params?: { refreshGrids?: boolean }) => {
  const { refreshGrids } = params ?? {};

  const offcanvasElement = document.getElementById('offcanvas');

  if (offcanvasElement) {
    const offcanvas = Offcanvas.getInstance(offcanvasElement);

    offcanvasElement.classList.remove('expanded');

    if (offcanvas) {
      offcanvas.hide();
    }
  } else {
    window.parent.dispatchEvent(new CustomEvent('escape'));

    if (refreshGrids) {
      window.parent.dispatchEvent(new CustomEvent('refreshGrids'));
    }
  }
};
